import React from "react";
import "./Common_Heading.css";

const Common_Heading = ({ headingText, subHeadingText }) => {
  return (
    <div className="Common_Heading">
      <p className="heading_title">{headingText}</p>
      <p className="sub_heading_title">{subHeadingText}</p>
    </div>
  );
};

export default Common_Heading;
